module.exports = __webpack_public_path__ + "img/troubleshooting.062026be.png";